import { useState, useEffect, useRef } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';

import { itemProduct } from 'utils/typeServices';
import { AdditionalServicesIcs, AdditionalServicesTracker, ProductsIcs, ProductsTracker, AdditionalServicesIcsMoto, AdditionalServicesTrackerMoto, AdditionalServicesIcsEV, AdditionalServicesIcsLight } from 'core/productsTemplate';

import Card from '../Card';
import NavTitle from 'components/views/NavTitle';
import Tooltip from 'components/views/Tooltip';
import { Typography } from '@mui/material';
import BoxMui from '@mui/material/Box';

import { Box, ContainerIcon, Section, SliderCards, Template, ButtonCustom } from './style';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { ReactComponent as IcHandUp } from 'assets/icons/ic-hand-up.svg';

type ParamsData = {
    title: string;
    subTitle: string;
    cdQuotation: number | undefined;
    product: 'seguro' | 'rastreador';
    listThePlan: Array<itemProduct>;
    isTracker?: boolean;
    isWebView: boolean;
    isEv?: boolean;
    isLight?: boolean;
    isOne?: boolean;
}

type ParamsProductList = {
    NM_PRODUTO_ADD: string;
    CD_PRODUTO_ADD: number;
    DS_TOOLTIP_ADD?: string;
}

type ParamsWithoutPlan = {
    title: string;
    covering: boolean;
}

type ParamsProductEquivalent = {
    [key: number]: () => number;
    default: () => boolean;
}

const SliderCard = ({ title, subTitle, product, listThePlan, isTracker = false, cdQuotation, isWebView, isEv, isLight = false, isOne = false }: ParamsData) => {
    const refScroll = useRef<HTMLElement>(null);
    const [stepScroll, setStepScroll] = useState(200);
    const [planRecommended, setPlanRecommended] = useState(true);
    const [listLightShow, setListLightShow] = useState<Array<number>>([]);
    const [productNav, setProductNav] = useState<Array<ParamsProductList>>([]);
    const [listThePlanState, setListThePlanState] = useState<Array<itemProduct>>([]);
    const [planesRecommended, setPlanesRecommended] = useState<Array<itemProduct>>([]);
    const [listTheDoublePlanLight, setListTheDoublePlanLight] = useState<Array<Array<itemProduct>>>([]);
    const [productCorrent, setProductCorrent] = useState(isTracker ? ProductsTracker : ProductsIcs);

    const productEquivalent: ParamsProductEquivalent = {
        2803: () => { return 2805 },
        2804: () => { return 2806 },
        2882: () => { return 2884 },
        2883: () => { return 2885 },
        2874: () => { return 2876 },
        2875: () => { return 2877 },
        2878: () => { return 2880 },
        2879: () => { return 2881 },
        2940: () => { return 2942 },
        2944: () => { return 2946 },
        2805: () => { return 2803 },
        2806: () => { return 2804 },
        2884: () => { return 2882 },
        2885: () => { return 2883 },
        2876: () => { return 2874 },
        2877: () => { return 2875 },
        2880: () => { return 2878 },
        2881: () => { return 2879 },
        2942: () => { return 2940 },
        2946: () => { return 2944 },
        default: () => { return false; }
    }

    const handleProductEquivalent: ((CD_PRODUTO: number) => number | boolean) = (CD_PRODUTO) => {
        return (productEquivalent[CD_PRODUTO] || productEquivalent.default)();
    };

    const handleSearchProductEquivalent = (Product: itemProduct) => {
        let productsEquivalents = [Product];
        setListLightShow(listLightShow => [...listLightShow, Product.cD_PRODUTO]);

        if (handleProductEquivalent(Product.cD_PRODUTO)) {
            const prdEquivalent = listThePlan.find(({ cD_PRODUTO }) => cD_PRODUTO === handleProductEquivalent(Product.cD_PRODUTO));
            prdEquivalent && productsEquivalents.push(prdEquivalent);
        }

        return productsEquivalents;
    }

    useEffect(() => {
        if (listThePlan && listThePlan.length > 1) {
            if (listThePlan[0].cD_PRODUTO === listThePlan[1].cD_PRODUTO) {
                const ListPlan = listThePlan.filter((plane, index) => index > 1);

                setPlanesRecommended([listThePlan[0], listThePlan[1]]);
                setListThePlanState(ListPlan);
            } else if (isLight) {
                let listTheDoublePlanLightAux: Array<Array<itemProduct>> = listTheDoublePlanLight;

                listThePlan.forEach((product) => {
                    if (product.nR_TIPO_PRODUTO === 12) {
                        if (!listTheDoublePlanLightAux.some(prdExist => prdExist.some(({ cD_PRODUTO }) => cD_PRODUTO === product.cD_PRODUTO))) {
                            listTheDoublePlanLightAux.push(handleSearchProductEquivalent(product));
                        }
                    }
                });

                setListTheDoublePlanLight(listTheDoublePlanLightAux);
            } else {
                setListThePlanState(listThePlan);
            }
        } else if (listThePlan.length === 1) {
            if (isLight) {
                let listTheDoublePlanLightAux: Array<Array<itemProduct>> = listTheDoublePlanLight;

                listThePlan.forEach((product) => {
                    if (product.nR_TIPO_PRODUTO === 12) {
                        if (!listTheDoublePlanLightAux.some(prdExist => prdExist.some(({ cD_PRODUTO }) => cD_PRODUTO === product.cD_PRODUTO))) {
                            listTheDoublePlanLightAux.push(handleSearchProductEquivalent(product));
                        }
                    }
                });

                setListTheDoublePlanLight(listTheDoublePlanLightAux);
            } else {
                setListThePlanState(listThePlan);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listThePlan]);

    useEffect(() => {
        if (product === 'rastreador') {
            setProductNav(handleArrayProductsTemplate(true));
        } else {
            setProductNav(handleArrayProductsTemplate(false));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product, listThePlanState]);

    useEffect(() => {
        if (isTracker && !isLight) {
            setProductCorrent(ProductsTracker);
        } else {
            setProductCorrent(ProductsIcs);
        }

    }, [isTracker, isLight]);

    const sliptPriceString = (VL_TOTAL: string, index: number) => {
        const auxString = VL_TOTAL.split(',');

        return auxString[index]?.replace(/[^0-9]/g, '');
    }

    const handleArrayProductsTemplate = (isTracker: boolean) => {
        let DataArray = [];

        if (isTracker) {
            if (listThePlanState.findIndex(({ cD_PRODUTO }) => ((cD_PRODUTO === 2430) || (cD_PRODUTO === 2431))) > -1) {
                DataArray = AdditionalServicesTrackerMoto;
            } else {
                DataArray = AdditionalServicesTracker;
            }
        } else {
            if (listThePlanState.findIndex(({ cD_PRODUTO }) => ((cD_PRODUTO === 2434) || (cD_PRODUTO === 2435))) > -1) {
                DataArray = AdditionalServicesIcsMoto;
            } else if (isEv) {
                DataArray = AdditionalServicesIcsEV;
            } else if (isLight) {
                DataArray = AdditionalServicesIcsLight;
            } else {
                DataArray = AdditionalServicesIcs;
            }
        }

        return DataArray;
    }

    const coveringPlan = (CD_PRODUTO_CURRENT: number, NR_PORCENTAGEM_INDENIZACAO: number, produtO_ATUAL: boolean) => {
        let auxArray: Array<ParamsWithoutPlan> = [];

        const planeShow = productCorrent.find(({ CD_PRODUTO }) => CD_PRODUTO === CD_PRODUTO_CURRENT);

        productNav.forEach(({ NM_PRODUTO_ADD, CD_PRODUTO_ADD }) => {
            if (CD_PRODUTO_ADD === 2 && NR_PORCENTAGEM_INDENIZACAO === 100) {
                auxArray.push({ title: NM_PRODUTO_ADD, covering: true });
            } else if (planeShow) {
                if (planeShow!.DS_PRODUTO.findIndex(({ CD_PRODUTO_ADD: CD_PRODUTO_ADD_ARRAY }) => CD_PRODUTO_ADD_ARRAY === CD_PRODUTO_ADD) >= 0) {
                    auxArray.push({ title: NM_PRODUTO_ADD, covering: true });
                } else {
                    auxArray.push({ title: NM_PRODUTO_ADD, covering: false });
                }
            } else {
                auxArray.push({ title: NM_PRODUTO_ADD, covering: false });
            }
        })

        return auxArray;
    }

    const handleClickScroll = (isNext: boolean) => {
        if (refScroll?.current) {
            if (isNext) {
                refScroll.current.scrollLeft = refScroll.current.scrollLeft + 265;
            } else {
                refScroll.current.scrollLeft = refScroll.current.scrollLeft - 265;
            }
        }
    }

    const handleStepScroll = () => {
        if (refScroll?.current?.scrollLeft) {
            setStepScroll(refScroll?.current?.scrollLeft);
        }
    }

    useEffect(() => {
        if (refScroll?.current) {
            refScroll.current.scrollLeft = 0;
        }
    }, [refScroll]);

    return (
        <Section>
            <nav>
                <NavTitle title={title} fontSize={{ xs: '1rem', md: '1.125rem' }} />
            </nav>
            {isLight &&
                <Box margin='-1.5rem 0 .74rem' sx={{ display: { xs: 'flex', md: 'none' } }}>
                    <Box
                        sx={{
                            position: 'absolute',
                            width: '2.1875rem',
                            height: '2.1875rem',
                            borderRadius: '100px',
                            backgroundColor: 'primary.light',
                            alignItems: 'center',
                            justifyContent: 'center',
                            'svg': {
                                height: 'auto !important'
                            }
                        }}>
                        <IcHandUp />
                    </Box>
                    <Typography margin='.21rem 0 0 1.6rem' color='primary.light' fontSize='.875rem' border='1px solid #17A7E0' padding='.44rem .75rem .31rem 1rem'>
                        Escolha a indenização <strong style={{ color: '#17A7E0' }}>ideal</strong> para você!
                    </Typography>
                </Box>
            }
            <Box>
                <Template>
                    <ContainerIcon typeproduct={!isTracker ? 'activeContainer' : 'disableContainer'} isOne={isOne ? 'active' : 'disable'}>
                        {/* {isEv &&
                            <IcIcsEv />
                        } */}
                    </ContainerIcon>
                    <nav>
                        <BoxMui textAlign='left'>
                            <Typography variant='h6' color='primary.light' fontWeight={700}>
                                {subTitle}
                            </Typography>
                            {isLight &&
                                <Box margin='1.44rem 0 2.33rem'>
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            width: '2.1875rem',
                                            height: '2.1875rem',
                                            borderRadius: '100px',
                                            backgroundColor: 'primary.light',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            'svg': {
                                                height: 'auto !important'
                                            }
                                        }}>
                                        <IcHandUp />
                                    </Box>
                                    <Typography margin='.21rem 0 0 1.6rem' color='primary.light' fontSize='.875rem' border='1px solid #17A7E0' padding='.5rem .3rem .3rem .75rem'>
                                        Escolha a indenização <strong style={{ color: '#17A7E0' }}>ideal</strong> para você!
                                    </Typography>
                                </Box>
                            }
                        </BoxMui>
                    </nav>
                    <ul>
                        {productNav.map(({ NM_PRODUTO_ADD, DS_TOOLTIP_ADD }, index) => (
                            <li key={index}
                                style={{
                                    padding: '3px 0 0 .625rem',
                                    height: `${(isTracker ? (isLight ? [1, 4] : [1, 6, 7]) : [5, 10]).indexOf(index) >= 0 ? '76px' : '35px'}`,
                                    background: (index % 2 !== 0) ? 'transparent' : 'rgba(227, 233, 242, 0.45)',
                                    borderBottom: (index % 2 !== 0) ? 'none' : '1px solid #E3E9F2'
                                }}>

                                {isTracker && [7].indexOf(index) >= 0 ?
                                    <Typography fontSize={14} fontWeight={400} lineHeight='1.2' dangerouslySetInnerHTML={{ __html: NM_PRODUTO_ADD }}></Typography>
                                    :
                                    <Typography fontSize={14} fontWeight={600} lineHeight='1.2'>
                                        {NM_PRODUTO_ADD} {DS_TOOLTIP_ADD && <Tooltip>{DS_TOOLTIP_ADD}</Tooltip>}
                                    </Typography>
                                }
                            </li>
                        ))}
                    </ul>
                </Template>
                <SliderCards>
                    <ButtonCustom sx={{ left: '310px' }} onClick={() => handleClickScroll(false)}>
                        <KeyboardArrowLeftIcon sx={{ color: 'primary.main', marginRight: '3px' }} />
                    </ButtonCustom>
                    <ScrollContainer innerRef={refScroll} className="scroll-container" onScroll={() => handleStepScroll()}>
                        {planesRecommended?.length > 0 &&
                            <li className='container-recommended'>
                                {planRecommended ?
                                    <Card
                                        cdQuotation={cdQuotation}
                                        cdQuotationItem={planesRecommended[1].cD_COTACAO_ITEM}
                                        nrTypeProduct={planesRecommended[1].nR_TIPO_PRODUTO}
                                        titleProduct={planesRecommended[1].nM_PRODUTO}
                                        product={!isTracker}
                                        codPlane={planesRecommended[1].cD_PRODUTO}
                                        VL_COMISSAO={planesRecommended[1].vL_COMISSAO_MINIMO}
                                        listWithoutPlan={
                                            coveringPlan(
                                                planesRecommended[1].cD_PRODUTO,
                                                planesRecommended[1].nR_PORCENTAGEM_INDENIZACAO,
                                                planesRecommended[1].produtO_ATUAL
                                            )}
                                        recommended={true}
                                        isShowModal={true}
                                        vL_TOTAL={planesRecommended[0].vL_TOTAL}
                                        price={sliptPriceString(planesRecommended[1].vL_TOTAL, 0)}
                                        cents={sliptPriceString(planesRecommended[1].vL_TOTAL, 1)}
                                        priceYearly={planesRecommended[1].vL_ANUAL}
                                        percentageIndem={planesRecommended[1].nR_PORCENTAGEM_INDENIZACAO}
                                        produtO_ATUAL={planesRecommended[1].produtO_ATUAL}
                                        isWebView={isWebView}
                                        dS_PRODUTO={planesRecommended[1].dS_PRODUTO}
                                    />
                                    :
                                    <Card
                                        cdQuotation={cdQuotation}
                                        cdQuotationItem={planesRecommended[0].cD_COTACAO_ITEM}
                                        nrTypeProduct={planesRecommended[0].nR_TIPO_PRODUTO}
                                        titleProduct={planesRecommended[0].nM_PRODUTO}
                                        product={!isTracker}
                                        codPlane={planesRecommended[0].cD_PRODUTO}
                                        VL_COMISSAO={planesRecommended[0].vL_COMISSAO_MINIMO}
                                        listWithoutPlan={
                                            coveringPlan(
                                                planesRecommended[0].cD_PRODUTO,
                                                planesRecommended[0].nR_PORCENTAGEM_INDENIZACAO,
                                                planesRecommended[1].produtO_ATUAL
                                            )}
                                        recommended={true}
                                        isShowModal={true}
                                        vL_TOTAL={planesRecommended[0].vL_TOTAL}
                                        price={sliptPriceString(planesRecommended[0].vL_TOTAL, 0)}
                                        cents={sliptPriceString(planesRecommended[0].vL_TOTAL, 1)}
                                        priceYearly={planesRecommended[0].vL_ANUAL}
                                        percentageIndem={planesRecommended[0].nR_PORCENTAGEM_INDENIZACAO}
                                        produtO_ATUAL={planesRecommended[0].produtO_ATUAL}
                                        isWebView={isWebView}
                                        dS_PRODUTO={planesRecommended[0].dS_PRODUTO}
                                    />
                                }
                            </li>
                        }

                        {!isLight && listThePlanState.map(({ nM_PRODUTO, cD_COTACAO_ITEM, nR_TIPO_PRODUTO, cD_PRODUTO, vL_TOTAL, vL_ANUAL, nR_PORCENTAGEM_INDENIZACAO, vL_COMISSAO_MINIMO, produtO_ATUAL, dS_PRODUTO }, index) =>
                            <li key={index}>
                                <Card
                                    cdQuotation={cdQuotation}
                                    cdQuotationItem={cD_COTACAO_ITEM}
                                    nrTypeProduct={nR_TIPO_PRODUTO}
                                    titleProduct={nM_PRODUTO}
                                    product={!isTracker}
                                    codPlane={cD_PRODUTO}
                                    VL_COMISSAO={vL_COMISSAO_MINIMO}
                                    listWithoutPlan={coveringPlan(cD_PRODUTO, nR_PORCENTAGEM_INDENIZACAO, produtO_ATUAL)}
                                    recommended={planesRecommended?.length > 0 ? false : index === 0 ? true : false}
                                    vL_TOTAL={vL_TOTAL}
                                    price={sliptPriceString(vL_TOTAL, 0)}
                                    cents={sliptPriceString(vL_TOTAL, 1)}
                                    priceYearly={vL_ANUAL}
                                    percentageIndem={nR_PORCENTAGEM_INDENIZACAO}
                                    produtO_ATUAL={produtO_ATUAL}
                                    isWebView={isWebView}
                                    dS_PRODUTO={dS_PRODUTO}
                                />
                            </li>
                        )}

                        {(listTheDoublePlanLight.length > 0 && isLight) &&
                            listTheDoublePlanLight.map((products) =>
                                products?.map(({ nM_PRODUTO, cD_COTACAO_ITEM, nR_TIPO_PRODUTO, cD_PRODUTO, vL_TOTAL, vL_ANUAL, nR_PORCENTAGEM_INDENIZACAO, vL_COMISSAO_MINIMO, produtO_ATUAL, dS_PRODUTO }, index) =>
                                    listLightShow.indexOf(cD_PRODUTO) >= 0 &&
                                    <li key={index}>
                                        <Card
                                            cdQuotation={cdQuotation}
                                            cdQuotationItem={cD_COTACAO_ITEM}
                                            nrTypeProduct={nR_TIPO_PRODUTO}
                                            titleProduct={nM_PRODUTO}
                                            product={!isTracker}
                                            codPlane={cD_PRODUTO}
                                            VL_COMISSAO={vL_COMISSAO_MINIMO}
                                            listWithoutPlan={coveringPlan(cD_PRODUTO, nR_PORCENTAGEM_INDENIZACAO, produtO_ATUAL)}
                                            recommended={false}
                                            price={sliptPriceString(vL_TOTAL, 0)}
                                            cents={sliptPriceString(vL_TOTAL, 1)}
                                            priceYearly={vL_ANUAL}
                                            dS_PRODUTO={dS_PRODUTO}
                                            produtO_ATUAL={produtO_ATUAL}
                                            vL_TOTAL={vL_TOTAL}
                                            isWebView={isWebView}
                                            percentageIndem={nR_PORCENTAGEM_INDENIZACAO}
                                            isEv={isEv}
                                            isLight={isLight}
                                            isOneExist={isOne}
                                            isOne={[2940, 2942, 2944, 2946].indexOf(cD_PRODUTO) >= 0}
                                            productsCard={products}
                                            activeLightIds={listLightShow}
                                            handleActiveLightIds={(listIds) => setListLightShow(listIds)}
                                        />
                                    </li>
                                ))}
                    </ScrollContainer>
                    {(((listThePlanState?.length - 1) * 260) > stepScroll) &&
                        <ButtonCustom sx={{ right: '10px' }} onClick={() => handleClickScroll(true)}>
                            <KeyboardArrowRightIcon sx={{ color: 'primary.main', marginLeft: '3px' }} />
                        </ButtonCustom>
                    }
                </SliderCards>
            </Box>
            <BoxMui sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                padding: '1rem 0 0 18.75rem',
                gap: '1rem'
            }}>
                <BoxMui sx={{
                    width: 'auto',
                    display: {
                        xs: 'none',
                        md: 'flex'
                    },
                    alignItems: 'center',
                    gap: '.5rem'
                }}>
                    {listThePlanState?.map((value, index) =>
                        <BoxMui
                            key={index}
                            sx={{
                                width: '10px',
                                height: '10px',
                                cursor: 'pointer',
                                transition: '200ms',
                                borderRadius: '100%',
                                backgroundColor: ((index * 260) < stepScroll) ? 'rgba(23, 167, 224, .8)' : 'rgba(0, 0, 0, .1)',
                                '&:hover': {
                                    backgroundColor: 'rgba(23, 167, 224, .4)'
                                }
                            }}
                            onClick={() => refScroll?.current && (refScroll.current.scrollLeft = (index * 265))}
                        />
                    )}
                </BoxMui>
            </BoxMui>
        </Section >
    )
}

export default SliderCard;